const ObjectCondition = {

    // FIELDS
    "name": "Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "objectCondition": "Object Condition",

    // ERROR
    "error_name": "Enter Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_status": "STATUS",

}

export default ObjectCondition;